var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"is-card"},[_vm._m(0),(_vm.hasForm)?[_c(_vm.componentForm.component,{tag:"component"})]:_vm._e(),(_vm.userCanAccessCreditCard)?_c('CreditCardCTA'):_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"is-bolder font-lg"},[_vm._v(" Olá ")]),_c('p',[_vm._v(" Aqui está o essencial para o seu dia. ")])])
}]

export { render, staticRenderFns }